import Typography from '@mui/material/Typography'
import { Role } from 'context/authentication/Role.types'
import { hasAccess } from 'global/helpers/authorization'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import DriverAssignmentField from './DriverAssignmentField'
import type { TripData } from './TripDashboard.types'

export interface DriverAssignmentProps {
  trip: TripData
  onChange?: (updatedTrip: TripData, action?: string) => void
}

const DriverAssignment = ({
  trip,
  onChange,
}: DriverAssignmentProps): ReactNode => {
  const { t } = useTranslation()

  if (hasAccess(Role.Editor)) {
    return (
      <DriverAssignmentField trip={trip} onChange={onChange} />
    )
  }

  if (trip.assignedDriver) {
    return (
      <Typography component="p" variant="p3" color="primary.main" noWrap>
        {trip.assignedDriver.name}
      </Typography>
    )
  }

  return (
    <Typography component="p" variant="p3" color="primary.light" noWrap>
      {t('screens.cs.trip_dashboard.card.not_assigned')}
    </Typography>
  )
}

export default DriverAssignment
